import axios from 'axios';
import { awsUrl, url, newApiBaseUrl, tshuvApi } from '../../axiosInstance';
import * as actionType from '../store/action'
import showAlert from './ShowAlert';
import { setPreload } from './CartsOpen';

export const reloedFunc = () => dispatch => dispatch({ type: actionType.RELOED })

export const createProduct = (data) => {
    return (
        axios.post(`${awsUrl}/v1/products`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.jwtToken}`,
            },
        }));
};

export const getOrphanProducts = () => {
    return dispatch => {
        axios.get(`${awsUrl}/v1/products/category/orphan`, {
            headers: {
                'Authorization': `bearer ${localStorage.jwtToken}`,
            },
        }).then(x => {
            dispatch({
                type: actionType.SET_PRODUCTS,
                payload: {
                    items: x.data
                }
            });
        }
        )
            .catch((e) => console.log(e));
        }
}

export const getSales = (stationId) => {
    return dispatch => {
        axios.get(`${url}sales?stationId=${stationId}`, {
            headers: {
                'Authorization': `bearer ${localStorage.token}`,
                "Access-Control-Allow-Origin": "*",
            },
        }).then(x => {
            dispatch({
                type: actionType.SET_PRODUCTS,
                payload: {
                    items: x.data
                    //  x.data.sort((a, b) => { return a.CategoryFullOrderNumber - b.CategoryFullOrderNumber }),
                    //                    items: x.data.sort((a, b) => { return a.orderNumber - b.orderNumber }).sort((a, b) => { return a.CategoryOrderNumber - b.CategoryOrderNumber }).sort((a, b) => { return a.CategoryFather1OrderNumber - b.CategoryFather1OrderNumber }),      
                }
            });

        })
            .catch(() => console.log("error"));
    }
}

export const getByMkt = (mkt, stationId) => {
    return dispatch => {
        axios.get(`${awsUrl}/v1/products/${mkt}?stationId=${stationId}`, {
            headers: {
                'Authorization': `bearer ${localStorage.jwtToken}`
            },
        })
            .then(x => dispatch({ type: actionType.SET_SELCTED_PRODUCT, data: x.data }))
            .catch(() => console.log("error"));

    }
}

export const getItemsPerCategoryCount = (id, stationId, count, mkt) => {
    return axios.get(`${awsUrl}/v1/products/${mkt}/category/${id}/count?stationId=${stationId}&count=${count}`, {
        headers: {
            'Authorization': `bearer ${localStorage.jwtToken}`,
        }
    })
}
export const getItemsPerCategory = (id, stationId, adminToCustomer = null) => {
    if (adminToCustomer === false) {
        return axios.get(`${awsUrl}/v1/products/category/${id}?customerShow=true&stationId=${stationId}`, {
            headers: {
                'Authorization': `bearer ${localStorage.jwtToken}`,
            }
        })
    }
    else {
        return axios.get(`${awsUrl}/v1/products/category/${id}?stationId=${stationId}`, {
            headers: {
                'Authorization': `bearer ${localStorage.jwtToken}`,
            }
        })
    }

}
export const getItemsPerCategoryDispatch = (id, stationId, adminToCustomer = null) => {
    return dispatch => {
        getItemsPerCategory(id, stationId, adminToCustomer)
            .then(x => {
                const items = x.data;
                items.sort((a, b) => a.CategoryFullOrderNumber - b.CategoryFullOrderNumber);
                dispatch({
                    type: actionType.SET_PRODUCTS,
                    payload: {
                        items
                        //: x.data.sort((a, b) => { return a.CategoryFullOrderNumber - b.CategoryFullOrderNumber })
                    }
                });
            })
            .catch(() => console.log("error"));
    }
}

let cancelToken;
export const getItemsPerWord = (word, stationId) => {
    return dispatch => {
        if (cancelToken) {
            cancelToken.cancel("Request canceled due to new input");
        }

        cancelToken = axios.CancelToken.source();
         axios.get(`${awsUrl}/v1/products/word?Word=${word}&stationId=${stationId}`, {
            headers: {
                Authorization: `bearer ${localStorage.jwtToken}`,
            },
            cancelToken: cancelToken.token
        }).then(x => {
            dispatch({
                type: actionType.SET_PRODUCTS,
                payload: {
                    items: x.data,
                }
            });

        })
            .catch(error => {
                if (axios.isCancel(error)) {
                    console.log("Request canceled:", error.message);
                } else {
                    console.log("error");
                }
            });
    }
}



export const UpdateSort = (data, stationId, adminToCustomer) => {
    return dispatch => {
        axios.post(`${url}UpdateSort`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.token}`,
                "Access-Control-Allow-Origin": "*"
            },
        })
            .then(response => {
                dispatch(getItemsPerCategoryDispatch(data.CategoryId, stationId, adminToCustomer)); // רענון הקטלוג
            })
            .catch(error => {
                console.error("Error updating product sort:", error);
                showAlert("עדכון הסדר נכשל, נסה שוב.");
            });
    };
};




export const UpdateProduct = (data) => {
    return axios.put(`${awsUrl}/v1/products`,
        data,
        {
            headers: {
                'Authorization': `bearer ${localStorage.jwtToken}`
            
            },
        })
}

export const AddProduct = (CategoryId) => {
    return dispatch => {
        dispatch(setPreload(true));
        axios.post(`${url}product?CategoryId=${CategoryId}`,
            {
                headers: {
                    'Authorization': `bearer ${localStorage.token}`,
                    "Access-Control-Allow-Origin": "*"
                },
            }).then(x => dispatch({ type: actionType.ADD_NEW_PRODUCT, payload: x.data }))
            .catch(() => console.log("error"))
            .finally(() => dispatch(setPreload(false)));
    }
}

export const GetProductEditMini = (mkt) => {
    return axios.get(`${awsUrl}/v1/products/${mkt}/mini`,
        {
            headers: {
                'Authorization': `bearer ${localStorage.jwtToken}`,
            },
        })
}

export const SetImgActive = (Mkt,imgDataId,imgName
) => {
    return dispatch => axios.put(`${awsUrl}/v1/products/image`,
        {
           Mkt,
           ImgId:imgDataId
        },
        {
            headers: {
                'Authorization': `bearer ${localStorage.jwtToken}`,
            },
        })
        .then(x => dispatch({ type: actionType.SET_UPDAATE_SELCED_PRODUCT, imgName }))
}

export const GetImgUrlProduct = (mkt) => {
    return axios.get(`${awsUrl}/v1/products/${mkt}/image`,
        {
            headers: {
                'Authorization': `bearer ${localStorage.jwtToken}`,
            },
        })
}

export const GetProducts = () => {
    return dispatch => axios.get(`${awsUrl}/v1/products`,
        {
            headers: {
                'Authorization': `bearer ${localStorage.jwtToken}`,
            },
        }).then(x => dispatch({ type: actionType.SET_ALL_SELECTED_PRODUCT, data: x.data }))
}

export const toggleFilter = (id, typeName) => {
    return dispatch => {
        dispatch({ type: actionType.TOGGLE_FILTER, payload: { id, typeName } })
    }
}

export const clearFilters = () => {
    return dispatch => {
        dispatch({ type: actionType.CLEAR_FILTER })
    }
}

export const clearSearch = () => {
    return dispatch => {
        dispatch({ type: actionType.DELETE_SEARCH })
    }
}

export const search = (word) => {
    return dispatch => {
        dispatch({ type: actionType.SET_SEARCH_PRODUCT, payload: word })
    }
}

export const setFilterSort = (bool) => {
    return dispatch => {
        dispatch({ type: actionType.SET_FILTER_SORT, payload: bool })
    }
}

export const getBrandNameById = (brandId) => {
    return axios.get(`${url}Product/GetBrandNameById?brandId=${brandId}`, {
        headers: {
            'Authorization': `bearer ${localStorage.token}`,
            "Access-Control-Allow-Origin": "*"
        },
    })
}

export const setPrice = (branch, gtin, price) => {
    const data = { 
        branch,
        gtin,
        price,
        retailer: "Hamazon"
    };

    axios.put(`${newApiBaseUrl}/admin/productprices`, data, {
        headers: {
            "Content-Type": "application/json",
            'Authorization': `bearer ${localStorage.jwtToken}`,
            "X-Tenant": "hamazon",
        }
    })
    .then((res) => {
        return res.data; 
    })
    .catch((error) => {
        console.error("Error updating price:", error.response ? error.response.data : error.message);
    });
};

export const setSailPrice = (data) => {

    axios.put(`${newApiBaseUrl}/admin/productpromotions`, data, {
        headers: {
            "Content-Type": "application/json",
            'Authorization': `bearer ${localStorage.jwtToken}`,
            "X-Tenant": "hamazon",
        }
    })
    .then((res) => {
        return res.data; 
    })
    .catch((error) => {
        console.error("Error updating price:", error.response ? error.response.data : error.message);
    });
};


export const getSails = async (branchId) => {
    try {
        const response = await axios.get(`${tshuvApi}/admin/promotions`);
        console.log("response from server", response)
        return response.data;
    } catch (error) {
    console.error("Error fetching data:", error);
  }
}